import {useEffect, useState} from 'react';

import {DialogContent, DialogActions} from '@mui/material';
import Box from '@mui/material/Box';

import {EXPORT_FORMATS} from '../../../../const';
import useBudget from '../../../../hooks/providers/useBudget';
import {getFileB64} from '../../../../utils';
import Button from '../../../form/buttons/Button/Button';
import BaseModal from '../../../modal/BaseModal';
import UploadDropzone from '../../../upload/UploadDropzone';
import BudgetsSelect from '../BudgetsSelect/BudgetsSelect';

const ImportBudgetFileModal = () => {
  const {alreadyTakenBudgetNames: budgets, selectedBudget, setSelectedBudget, importBudgetFile, isImportBudgetModalOpen: isOpen, setIsImportBudgetModalOpen: setIsOpen} = useBudget();
  const [files, setFiles] = useState(null);

  const closeModal = () => {
    setIsOpen(false);
  };

  const handleSubmit = async () => {
    try {
      const base64 = await getFileB64(files[0]);
      const rawBase64 = base64.split(',')[1];

      importBudgetFile(rawBase64, EXPORT_FORMATS.XLSX);
      closeModal();
    } catch (err) {
      console.error('Error converting budget file to base64', err);
    }
  };

  useEffect(() => {
    if ((budgets || []).length === 1 && isOpen) {
      setSelectedBudget(budgets[0]);
    }
  }, [budgets, isOpen]);

  const submitButtonDisabled = !selectedBudget || !files || (files && files.length === 0);

  return (
    <BaseModal onClose={closeModal} open={isOpen} title="Importer un budget">
      <DialogContent>
        <BudgetsSelect disabled={(budgets || []).length === 1} onSelect={setSelectedBudget} />
        <Box mt={1}>
          <UploadDropzone
            maximumNumberOfFiles={1}
            error=""
            onFilesUpload={setFiles}
            acceptedFileTypes={{
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx']
            }}
          />
        </Box>
      </DialogContent>

      <DialogActions sx={{justifyContent: 'center', mt: 1}}>
        <Button variant="outlined" color="primary" onClick={closeModal}>
          Fermer
        </Button>
        <Button variant="contained" color="secondary" disabled={submitButtonDisabled} onClick={handleSubmit}>
          Importer
        </Button>
      </DialogActions>
    </BaseModal>
  );
};

export default ImportBudgetFileModal;
